import { useState } from 'react';
import { Trash2, AlertTriangle, Key } from 'lucide-react';
import { userApi } from '../../api/userApi';
import { useNavigate } from 'react-router-dom';

const DeleteAccountSection = () => {
    const [isConfirming, setIsConfirming] = useState(false);
    const [password, setPassword] = useState('');
    const [isDeleting, setIsDeleting] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleDelete = async () => {
        setIsDeleting(true);
        setError('');
        try {
            await userApi.deleteAccount(password || undefined);
            localStorage.clear();
            navigate('/login');
        } catch (err: any) {
            setError(err.message || 'Error al eliminar la cuenta');
            setIsDeleting(false);
        }
    };

    return (
        <div className="space-y-6">
            <div className="bg-red-50 border border-red-200 rounded-2xl p-6">
                <div className="flex items-start gap-4">
                    <div className="p-3 bg-red-100 rounded-xl">
                        <AlertTriangle className="w-6 h-6 text-red-600" />
                    </div>
                    <div>
                        <h3 className="text-lg font-bold text-red-900">Zona de Peligro</h3>
                        <p className="text-red-700 mt-1">
                            La eliminación de cuenta es irreversible. Perderás acceso a todos los salones, citas y datos asociados a tu usuario.
                        </p>
                    </div>
                </div>

                {!isConfirming ? (
                    <div className="mt-6 flex justify-end">
                        <button
                            onClick={() => setIsConfirming(true)}
                            className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white font-medium rounded-xl transition-colors flex items-center gap-2 hover:shadow-lg hover:shadow-red-500/20"
                        >
                            <Trash2 className="w-4 h-4" />
                            Eliminar mi cuenta
                        </button>
                    </div>
                ) : (
                    <div className="mt-6 bg-white p-6 rounded-xl border border-red-100 animate-in fade-in slide-in-from-top-2 shadow-sm">
                        <h4 className="font-semibold text-gray-900 mb-2">Confirmar eliminación</h4>
                        <p className="text-sm text-gray-500 mb-4">
                            Esta acción no se puede deshacer. Ingresa tu contraseña para confirmar.
                            <br />
                            <span className="text-xs italic text-gray-400">Si iniciaste sesión con Google, puedes dejar este campo vacío.</span>
                        </p>

                        <div className="space-y-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Contraseña actual
                                </label>
                                <div className="relative">
                                    <Key className="absolute left-3 top-3 w-5 h-5 text-gray-400" />
                                    <input
                                        type="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none transition-all"
                                        placeholder="Tu contraseña"
                                    />
                                </div>
                            </div>

                            {error && (
                                <p className="text-sm text-red-600 font-medium bg-red-50 p-3 rounded-lg border border-red-100 flex gap-2 items-center">
                                    <AlertTriangle className="w-4 h-4" />
                                    {error}
                                </p>
                            )}

                            <div className="flex justify-end gap-3 pt-2">
                                <button
                                    onClick={() => {
                                        setIsConfirming(false);
                                        setPassword('');
                                        setError('');
                                    }}
                                    className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-lg font-medium transition-colors"
                                    disabled={isDeleting}
                                >
                                    Cancelar
                                </button>
                                <button
                                    onClick={handleDelete}
                                    disabled={isDeleting}
                                    className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white font-medium rounded-lg flex items-center gap-2 disabled:opacity-50 transition-all shadow-md hover:shadow-xl hover:shadow-red-500/20"
                                >
                                    {isDeleting ? (
                                        <>Procesando...</>
                                    ) : (
                                        <>
                                            <Trash2 className="w-4 h-4" />
                                            Sí, eliminar permanentemente
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DeleteAccountSection;
